import type { ThemeOptions } from '@mui/material';

import { black, gray, white } from '~/styles/colors';

const DataGridTheme: ThemeOptions['components'] = {
  MuiDataGrid: {
    styleOverrides: {
      root: {
        backgroundColor: white,
        border: `1px solid ${black[200]}`,
        '&.MuiDataGrid-root .MuiDataGrid-cell:focus-within': {
          outline: 'none !important',
        },
        '&:MuiDataGrid-virtualScrollerRenderZone': {
          border: 'none',
          outline: 'none !important',
        },
      },
      cell: ({ theme: contextTheme }) => ({
        '&:first-of-type': {
          paddingLeft: contextTheme.spacing(3),
          [contextTheme.breakpoints.down(1024)]: {
            paddingLeft: contextTheme.spacing(2),
          },
        },
        '&:last-of-type': {
          paddingRight: contextTheme.spacing(2),
          [contextTheme.breakpoints.down(1024)]: {
            paddingLeft: contextTheme.spacing(1.5),
          },
        },
        padding: `0 ${contextTheme.spacing(1)}`,
        borderBottom: `1px ${black[200]} solid`,
        // Disable cell outline on mouse-click
        '&:active': {
          outline: 'none',
        },
      }),
      columnHeader: ({ theme: contextTheme }) => ({
        backgroundColor: white,
        borderColor: 'blue',
        '&:first-of-type': {
          paddingLeft: contextTheme.spacing(3),
          [contextTheme.breakpoints.down(1024)]: {
            paddingLeft: contextTheme.spacing(2),
          },
        },
        '&:last-of-type': {
          paddingRight: contextTheme.spacing(4),
          [contextTheme.breakpoints.down(1024)]: {
            paddingLeft: contextTheme.spacing(2),
          },
        },
        padding: `0 ${contextTheme.spacing(1)}`,
        '&:hover': {
          backgroundColor: black[100],
          cursor: 'pointer',
        },
        '&:focus': {
          outline: 'none',
        },
      }),
      columnHeaders: {
        '& .MuiDataGrid-columnSeparator': {
          display: 'none !important',
        },
      },
      columnHeaderTitle: ({ theme: contextTheme }) => ({
        ...contextTheme.typography.body1,
        lineHeight: '18px',
        color: gray[600],
      }),
      columnSeparator: {
        color: black[200],
        '&:hover': {
          color: black[500],
        },
      },
      footerContainer: {
        borderBottom: 'none',
      },
      row: {
        '&:hover': {
          backgroundColor: black[100],
          cursor: 'pointer',
        },
      },
    },
    defaultProps: {
      disableColumnFilter: true,
      autoHeight: true,
      disableColumnMenu: true,
    },
  },
};

export default DataGridTheme;
